import { useEffect, useState } from "react";
import SideBar from "../components/sideBar";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import translateText, {
  currentLanguage,
} from "../signals/language.signal";
import { cartProductData } from "../signals/orderData.signal";
import { getStorage, setStorage } from "../helpers/helper";
import { logClientMobileNumber, logClientNumber, signalPagePath } from "../signals/login.signal";
import { Link, useNavigate } from "react-router-dom";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
const Checkout = () => {
  const [total, setTotal] = useState("0");
  const [orderConfirm, setOrderConfirm] = useState();
  const [Loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    cartProductData.value = [];
    cartProductData.value = getStorage("cartData");
    var countToal = 0;
    cartProductData.value.forEach((element) => {
      countToal += element.QUANTITY * element.PRICE;
    });
    setTotal(countToal);
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    setDisabled(true);
    try {
      const username = "Guthmi";
      const password = "ApiCal2023@_2115&";
      const basicAuth = btoa(username + ":" + password);

      const response = await fetch("https://alguthmi.co/API/B2BAppAPI/insertHOrder.php", {
        method: "POST",
        headers: {
          Authorization: `Basic ${basicAuth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CLICODE: logClientNumber.value,
          MOBLILENO: logClientMobileNumber.value,
        }),
      });

      if (response.ok) {
        const jsonResponse = await response.json();
        for (const element of cartProductData.value) {
          try {
            const response = await fetch(
              "https://alguthmi.co/API/B2BAppAPI/insertDOrder.php",
              {
                method: "POST",
                headers: {
                  Authorization: `Basic ${basicAuth}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  CLICODE: logClientNumber.value,
                  MOBLILENO: logClientMobileNumber.value,
                  TRANNO: jsonResponse.TRANNO,
                  ARTCODE: element.SQU,
                  QTY: element.QUANTITY,
                  DISCOUNT: 0,
                  WHS: element.WAREHOUSEID,
                  NOTES: element.NOTE,
                }),
              }
            );

            if (response.ok) {
              const jsonResponse = await response.json();
            } else {
              console.error("Detail Insertion failed:", await response.text());
            }
          } catch (error) {
            console.error("Error inserting detail:", error);
          }
        }
        cartProductData.value = [];
        setStorage("cartData", cartProductData.value);
        setOrderConfirm(jsonResponse.TRANNO);
      } else {
        console.error("Header Insertion failed:", await response.text());
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  return (
    <div
      id="card"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        title={translateText(currentLanguage.value, "Checkout")}
        back={true}
        backFunction={() => {
          navigate(-1);
        }}
      />

      {cartProductData.value ? (
        cartProductData.value.length != 0 ? (
          <>
            <div className="container pt-3 align-items-sm-center loginContaner  d-flex justify-content-center w-100 flex-md-row flex-wrap">
              <div className="w-100 p-3 shadow rounded-3 mb-3">
                <h6 className="m-0">
                  {" "}
                  {translateText(currentLanguage.value, "PaymentDetails")}
                </h6>
                <div className="p-3">
                  <p style={{ fontSize: "12px" }}>
                    {translateText(currentLanguage.value, "PaymentMethod")}
                  </p>
                  <div className="form-check form-check-inline w-100">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="Payment"
                      id="inlineCheckbox1"
                      value="option1"
                      checked
                    ></input>
                    <label className="form-check-label" htmlFor="inlineCheckbox1">
                    {translateText(currentLanguage.value, "Cash")}
                    </label>
                  </div>
                  <div className="form-check form-check-inline w-100">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="Payment"
                      id="inlineCheckbox2"
                      value="option2"
                      disabled
                    ></input>
                    <label className="form-check-label" htmlFor="inlineCheckbox2">
                      {translateText(currentLanguage.value, "DebitCredit")}
                    </label>
                  </div>
                </div>
              </div>
              <div className="w-100 p-3 shadow rounded-3">
                <h6 className="m-0">
                  {" "}
                  {translateText(currentLanguage.value, "OrderSummary")}
                </h6>
                <div className="p-3 pb-0 d-flex justify-content-between flex-wrap flex-row">
                  <p className="m-0">
                    {" "}
                    {translateText(currentLanguage.value, "total")}
                  </p>
                  <p className="m-0">{total}</p>
                </div>
                <div className="p-3 pb-0 d-flex justify-content-between flex-wrap flex-row">
                  <p className="m-0">
                    {" "}
                    {translateText(currentLanguage.value, "DeliveryFees")}
                  </p>
                  <p className="m-0">{0}</p>
                </div>
                <hr />
                <div className=" pb-0 d-flex justify-content-between flex-wrap flex-row">
                  <h6 className="m-0">
                    {" "}
                    {translateText(currentLanguage.value, "Total")}
                  </h6>
                  <h6 className="m-0">{total}</h6>
                </div>
              </div>

              <div className=" position-absolute bottom-0 shadow-lg loginContaner p-3 flex-row w-100 rounded-3 d-md-flex  justify-content-between align-items-center">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="btn btn-primary border pe-3 ps-3 w-100 "
                  disabled={disabled}
                  style={{
                    background: primary.value,
                    color: primaryFount.value,
                  }}
                >
                  {Loading
                    ? translateText(currentLanguage.value, "Loading") + "..."
                    : translateText(currentLanguage.value, "ConfirmOrder")}
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="p-3 position-absolute flex-column bg-body w-100 h-100 top-0 d-flex align-items-center justify-content-center">
          <h1 style={{ fontSize: "50px" }}>{translateText(currentLanguage.value, "Thank")}</h1>
          <TaskAltIcon style={{ fontSize: "150px", color: primary.value }} />
          <p className="m-0 text-center" style={{ fontSize: "15px" }}>
          {translateText(currentLanguage.value, "ThankBady")} {' '} ({orderConfirm})
          </p>
          <p></p>
          <Link
            to={signalPagePath.value ? "/myOrder" : "/"}
            className="btn btn-primary border pe-3 ps-3 w-100 mb-3"
            style={{ background: primary.value, color: primaryFount.value }}
          >
            {translateText(currentLanguage.value, "MyOrderTitle")}
          </Link>
          <Link
            to={signalPagePath.value ? "/product" : "/"}
            className="btn btn-primary border pe-3 ps-3 w-100"
            style={{ border: primary.value, background: primaryFount.value ,color: primary.value }}
          >
            {translateText(currentLanguage.value, "ProductTitle")}
          </Link>
        </div>
        )
      ) : (
        <div className="p-3 position-absolute flex-column bg-body w-100 h-100 top-0 d-flex align-items-center justify-content-center">
          <h1 style={{ fontSize: "50px" }}>{translateText(currentLanguage.value, "Thank")}</h1>
          <TaskAltIcon style={{ fontSize: "150px", color: primary.value }} />
          <p className="m-0 text-center" style={{ fontSize: "15px" }}>
          {translateText(currentLanguage.value, "ThankBady")} {' '} ({orderConfirm})
          </p>
          <p></p>
          <Link
            to={signalPagePath.value ? "/myOrder" : "/"}
            className="btn btn-primary border pe-3 ps-3 w-100"
            style={{ background: primary.value, color: primaryFount.value }}
          >
            {translateText(currentLanguage.value, "MyOrderTitle")}
          </Link>
          <Link
            to={signalPagePath.value ? "/product" : "/"}
            className="btn btn-primary border pe-3 ps-3 w-100"
            
          >
            {translateText(currentLanguage.value, "ProductTitle")}
          </Link>
        </div>
      )}
    
    </div>
  );
};

export default Checkout;
